export const SLOW_VIDEO_SPEED = 0.6;

/**
 * Playback runs at SLOW_VIDEO_SPEED, but the copy shown to learners deliberately
 * reads 0.50x, so the two values are intentionally out of step.
 */
export const SLOW_VIDEO_SPEED_LABEL = '0.50x';
